<template>
  <section
    id="login"
  >
    <v-row dense no-gutters>
      <v-col
        cols="12"
        lg="7"
        :hidden="$vuetify.breakpoint.mdAndDown"
      >
        <v-card
          width="100%"
          height="100vh"
          color="primary"
          class="d-flex flex-column justify-center align-center"
          tile
          flat
          dark
        >
          <div class="my-5">
            <v-img
              width="120px"
              height="auto"
              :src="require('@/assets/images/logos/logo_circle_white.png')"
            ></v-img>
          </div>
          <div class="text-h1 font-weight-medium">
            Intranet Portal
          </div>
        </v-card>
      </v-col>
      <v-col
        cols="12"
        lg="5"
      >
        <v-card
          width="100%"
          height="100vh"
          color="grey lighten-4"
          class="d-flex flex-column justify-center align-center"
          tile
          flat
        >
          <!-- <div style="width: 320px;">
              <v-img
                  alt="Page 404"
                  src="@/assets/images/logos/logo_side_round_w350.png"
              />
          </div> -->
          <div class="text-h3 font-weight-medium my-4">
            Welcome Back
          </div>
          <v-card
            max-width="400px"
            color="transparent"
            flat
            tile
          >
            <v-alert v-if="message" dense outlined type="error" dismissible>
              {{ message }}
            </v-alert>
            <v-form ref="form" @submit.prevent="handleLogin">
                <v-row>
                    <v-col cols="12">
                      <v-text-field
                        v-model="credential.userName"
                        label="User Name"
                        placeholder=" "
                        required
                        :counter="50"
                        :disabled="loading"
                        :rules="[required, max50]"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12">
                      <v-text-field
                        v-model="credential.password"
                        label="Password"
                        placeholder=" "
                        required
                        :disabled="loading"
                        :rules="[required, min6]"
                        :append-icon="hidePassword ? 'mdi-eye-off' : 'mdi-eye'"
                        :type="hidePassword ? 'password' : 'text'"
                        hint="At least 6 characters"
                        counter
                        @click:append="hidePassword = !hidePassword"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="6">
                      <v-btn 
                        color="primary" 
                        type="submit"
                        :loading="loading"
                        :block="$vuetify.breakpoint.mdAndDown"
                      >
                        Login
                      </v-btn>
                    </v-col>
                    <v-col cols="12" md="6" class="text-right">
                      <v-btn
                        text
                        color="primary"
                        to="/auth/forget-password"
                        :block="$vuetify.breakpoint.mdAndDown"
                      >
                        Forget Password
                      </v-btn>
                    </v-col>
                </v-row>
            </v-form>
          </v-card>
        </v-card>
      </v-col>
    </v-row>

    <v-overlay v-if="!!userProfileList" :value="userProfileList" :opacity="0.9" width="300">
      <v-list 
        light
        width="300"
      >
        <v-subheader class="text-h6">
          Select security profile
        </v-subheader>
        <div v-for="(userProfile) in userProfileList" :key="'profile-divider-' + userProfile.userOrgProfileId">
          <v-divider />
          <v-list-item
            :key="'profile-item-' + userProfile.userOrgProfileId"
            @click="handleSwitchUserProfile(userProfile)"
          >
            <v-list-item-content>
              <v-list-item-title>
                {{ userProfile.securityProfileName }}
              </v-list-item-title>
              <v-list-item-subtitle>
                {{ userProfile.organizationName }}
              </v-list-item-subtitle>
              <v-list-item-subtitle>
                <small>{{ userProfile.originationChannelName }}</small>
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </div>
      </v-list>
    </v-overlay>
  </section>
</template>

<script>
import User from "@/models/user";
import { rules, convert } from "@/mixins";

export default {
  name: "Login",
  data() {
    return {
      credential: new User("", ""),
      userProfileList: null,
      hidePassword: true,
      loading: false,
      message: "",
    };
  },
  methods: {
    async handleLogin() {
      this.loading = true;
      this.message = "";

      if (this.$refs.form.validate() === true) {
          this.userProfileList = await this.$store.dispatch("auth/getUserProfileListWithCredential", this.credential).then(
            (resp) => {
              return resp;
            },
            (error) => {
              this.message = this.toErrorMessage(error);
              return null;
            }
          );
      }

      this.loading = false;
    },
    async handleSwitchUserProfile(userProfile) {
      await this.$store.dispatch("auth/setUserProfile", userProfile);
      await this.$store.dispatch("auth/getNavMenuList");
      this.$router.push(this.$route.query.returnUrl ? this.$route.query.returnUrl : '/dashboard');
    }
  },
  mixins: [rules, convert]
};
</script>
